import { render, staticRenderFns } from "./CascaderItem.vue?vue&type=template&id=ae7a135c&"
import script from "./CascaderItem.vue?vue&type=script&lang=js&"
export * from "./CascaderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports